module.exports = __webpack_public_path__ + "img/twine.2fc74be6.png";